<template>
    <div>
        <p>
            {{ introText }}
        </p>

        <div class="flex -mx-2xl">
            <div
                class="flex items-center flex-col w-1/2 text-center bg-neutral-lighter p-sm"
            >
                {{ lang(
                    'Använd de förinställda inställningarna för nätverksnamn och lösenord',
                    'Use the preset settings for network name and password'
                ) }}
            </div>
            <div
                class="flex justify-center flex-col w-1/2 text-center p-sm"
            >
                {{ lang ('Välj nätverksamn och lösenord själv (rekommenderas)','Submit your own network name and password (recommended)') }}
            </div>
        </div>
        <div class="flex -mx-2xl -mb-2xl">
            <div class="w-1/2 flex justify-center bg-neutral-lighter p-sm">
                <button class="btn btn-sm is-ghost my-md" @click="$emit('complete')">
                    {{ lang('Välj','Select') }}
                </button>
            </div>
            <div class="w-1/2 flex justify-center p-sm">
                <button class="btn btn-sm my-md is-primary" @click="$emit('next')">
                    {{ lang('Välj','Select') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                introText: lang(
                    'Vi rekommenderar att du ställer in ett eget namn på ditt nätverk, och att du väljer ett eget lösenord för det trådlösa nätverket. Men om du inte vill det så kan du gå vidare med våra förinställda värden.',
                    'We recomment that you choose a name for your network, and that you set your own password for the wireless network. But if you would rather prefer to use our preinstalled settings, you may do so.'
                ),
            };
        },
        mounted() {
            this.$emit(
                'title',
                lang('Hur vill du ställa in routern?', 'How do you wish to configure the router?')
            );
        },
    };
</script>